import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';

export const useTerminalPerformanceStore = defineStore('terminalPerformance', {
  state: () => ({
    terminals: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    totalPages: 0,
    period: 'this_month',
    filters: {
      state: '',
      paymentMethod: 'ALL',
      inactivePeriod: 'ALL',
      filterType: '', // 新增：'terminal' 或 'card'
      fleet_id: '',
      search: '',
    },
    customStartDate: '',
    customEndDate: '',
  }),
  actions: {
    async fetchTerminalPerformances() {
      const url = `/api/admin/terminalPerformance/list`;
      const params = new URLSearchParams({
        per_page: this.itemsPerPage,
        page: this.currentPage,
        period: this.period,
      });
      
      if (this.filters.state) {
        params.append('state', this.filters.state);
      }
      if (this.filters.paymentMethod !== 'ALL') {
        params.append('payment_method', this.filters.paymentMethod);
      }
      if (this.filters.inactivePeriod !== 'ALL') {
        params.append('inactive_period', this.filters.inactivePeriod);
      }
      if (this.filters.fleet_id) {
        params.append('fleet_id', this.filters.fleet_id);
      }
      if (this.filters.search) {
        params.append('search', this.filters.search);
      }
      
      if (this.period === 'custom' && this.customStartDate && this.customEndDate) {
        params.append('custom_start', this.customStartDate);
        params.append('custom_end', this.customEndDate);
      }
      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        this.terminals = response.data.terminals;
        this.totalEntries = response.data.total;

        this.totalPages = Math.ceil(this.totalEntries / this.itemsPerPage);
      } catch (error) {
        console.error('Error fetching terminal performances:', error);
      }
    },
    setInactivePeriod(period) {
      this.filters.inactivePeriod = period;
    },
    setFilterType(type) {
      this.filters.filterType = type;
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchTerminalPerformances();
      }
    },
    resetState() {
        this.$reset(); // 使用 Pinia 的內建 $reset 方法來重置 state
    },
  },
});
